import { render, staticRenderFns } from "./BaseShortcut.vue?vue&type=template&id=92f6ac20"
import script from "./BaseShortcut.vue?vue&type=script&lang=js"
export * from "./BaseShortcut.vue?vue&type=script&lang=js"
import style0 from "./BaseShortcut.vue?vue&type=style&index=0&id=92f6ac20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports